import { Select, Typography } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import { TableSearchOption } from './types';

type FilterListColumn = {
  title: string;
  dataIndex: string;
  FilterListTextBoxFilterable?: boolean;
};

type FilterListTextBoxProps = {
  optionsToFilter: any[];
  columnsToFilter: FilterListColumn[];
  setFilteredOptions: (options: any[]) => void;
};

export default function FilterListTextBox(props: FilterListTextBoxProps): ReactElement {
  const { optionsToFilter, columnsToFilter, setFilteredOptions } = props;

  const [searchText, setSearchText] = useState<string>('');
  const [appliedFilterOptions, setAppliedFilterOptions] = useState<TableSearchOption[]>([]);
  const [searchPossibilities, setSearchPossibilities] = useState({});

  function filterOption() {
    if (appliedFilterOptions.length > 0) {
      let filtered: any[] = optionsToFilter;

      for (let a = 0; a < appliedFilterOptions.length; a++) {
        if (appliedFilterOptions[a].type === 'exact') {
          filtered = filtered.filter(f => {
            if (appliedFilterOptions[a].value.toString().toLowerCase() === 'null')
              return f[appliedFilterOptions[a].column] == null;
            if (f[appliedFilterOptions[a].column] || f[appliedFilterOptions[a].column] == 0) {
              return (
                f[appliedFilterOptions[a].column].toString().toLowerCase() ==
                appliedFilterOptions[a].value.toString().toLowerCase()
              );
            }
          });
        } else if (appliedFilterOptions[a].type === 'contains') {
          filtered = filtered.filter(f => {
            if (f[appliedFilterOptions[a].column] || f[appliedFilterOptions[a].column] == 0) {
              return f[appliedFilterOptions[a].column]
                .toString()
                .toLowerCase()
                .includes(appliedFilterOptions[a].value.toString().toLowerCase());
            }
          });
        } else if (appliedFilterOptions[a].type === 'nullOrBlank') {
          filtered = filtered.filter(f => {
            if (!f[appliedFilterOptions[a].column] && f[appliedFilterOptions[a].column] != 0) {
              return true;
            } else {
              return false;
            }
          });
        } else if (appliedFilterOptions[a].type === 'notNullOrBlank') {
          filtered = filtered.filter(f => {
            if (f[appliedFilterOptions[a].column] || f[appliedFilterOptions[a].column] == 0) {
              return true;
            } else {
              return false;
            }
          });
        } else if (appliedFilterOptions[a].type === 'like') {
          const anyFieldFiltered: any[] = [];
          for (let c = 0; c < columnsToFilter.length; c++) {
            if (columnsToFilter[c].FilterListTextBoxFilterable) {
              filtered.filter(f => {
                if (
                  (f[columnsToFilter[c].dataIndex] || f[columnsToFilter[c].dataIndex] == 0) &&
                  f[columnsToFilter[c].dataIndex]
                    .toString()
                    .toLowerCase()
                    .includes(appliedFilterOptions[a].value.toString().toLowerCase())
                ) {
                  anyFieldFiltered.push(f);
                }
              });
            }
          }
          filtered = [...new Set(anyFieldFiltered)];
        }
      }

      setFilteredOptions(filtered);
    } else {
      setFilteredOptions(optionsToFilter);
    }
  }

  useEffect(() => {
    filterOption();
  }, [appliedFilterOptions]);

  useEffect(() => {
    if (
      optionsToFilter &&
      columnsToFilter &&
      optionsToFilter.length > 0 &&
      columnsToFilter.length > 0
    ) {
      const possibilities = {};
      for (let i = 0; i < columnsToFilter.length; i++) {
        if (columnsToFilter[i].FilterListTextBoxFilterable) {
          possibilities[columnsToFilter[i].dataIndex] = optionsToFilter.map(o => {
            return o[columnsToFilter[i].dataIndex];
          });
          possibilities[columnsToFilter[i].dataIndex] = [
            ...new Set(possibilities[columnsToFilter[i].dataIndex])
          ];
        }
      }
      setSearchPossibilities(possibilities);
      filterOption();
    } else {
      setFilteredOptions([]);
    }
  }, [optionsToFilter]);

  const exactFilteredColumns = appliedFilterOptions
    .filter(f => f.type === 'exact')
    .map(f => f.column);
  const options =
    searchText.length > 0
      ? Object.keys(searchPossibilities)
          .filter(columnName => !exactFilteredColumns.includes(columnName))
          .reduce((acc, columnName) => {
            // const columnDetails = props.columns.find(c =>
            //   !Array.isArray(c.dataIndex)
            //     ? c.dataIndex === columnName
            //     : JSON.stringify(c.dataIndex) === JSON.stringify(columnName.split('.'))
            // );

            const columnLabel = columnsToFilter.filter(c => {
              return c.dataIndex == columnName;
            })[0].title;

            const optionsForColumn = searchPossibilities[columnName];
            //const matchingValues: string[] = [];
            acc.push(
              ...optionsForColumn
                .map(value => {
                  // let label: string = value;
                  // if (columnDetails?.render) {
                  //   try {
                  //     const renderedValue = columnDetails.render(
                  //       columnName.endsWith('_date') ? new Date(value) : value,
                  //       null,
                  //       0
                  //     );
                  //     if (typeof renderedValue === 'string') label = renderedValue;
                  //   } catch (err) {
                  //     console.debug(err);
                  //   }
                  // }

                  let label: string = '(empty)';
                  if (value || value == 0) {
                    label = value.toString();
                  }

                  // Needed for contains search below (!! Side Effect !!)
                  // if ((value + label).toLowerCase().includes(searchText.toLowerCase()))
                  //   matchingValues.push(value);

                  return {
                    key: columnName + value + 'exact',
                    column: columnName,
                    value: value || 'NULL',
                    // label: value
                    //   ? t('tableHeader.exactLabel', '{{column}}: {{label}}', {
                    //       column: columnLabel,
                    //       label
                    //     })
                    //   : t('tableHeader.emptyLabel', {
                    //       column: columnLabel
                    //     }),
                    label: `${columnLabel}: ${label}`,
                    type: 'exact' as TableSearchOption['type']
                  };
                })
                .filter(({ label }) => label.toLowerCase().includes(searchText.toLowerCase()))
            );

            // Allow filter for any row where the value contains the search text
            // if (matchingValues.length > 0) {
            acc.push({
              key: `${columnName}${searchText}like`,
              column: columnName + '_like',
              value: searchText,
              // label: t('tableHeader.containsLabel', {
              //   column: columnLabel,
              //   searchText
              // }),
              label: `${columnLabel} contains "${searchText}"`,
              type: 'like'
            });
            // }

            // Allow select any row where the value is not null
            if (
              columnLabel.toLowerCase().includes(searchText.toLowerCase()) &&
              optionsForColumn.some(o => !!o)
            ) {
              acc.push({
                key: columnName + '_set',
                column: columnName,
                value: 'NOT NULL',
                // label: t('tableHeader.notEmptyLabel', {
                //   column: columnLabel
                // }),
                label: `${columnLabel} is set`,
                type: 'notNullOrBlank'
              });
            }
            return acc;
          }, [] as TableSearchOption[])
          .sort((a, b) => (a.type === 'exact' && b.type === 'contains' ? 1 : -1))
      : [];

  const filterSearch = document.getElementById('filterDropdown');

  function addFilter(optionKey: string) {
    if (optionKey === 'filter-all') {
      filterAllColumns();
      setSearchText('');
      filterSearch?.blur();
    } else {
      const optToAdd = options.find(o => o.key === optionKey);

      if (optToAdd !== undefined) {
        let filters = appliedFilterOptions;
        filters = filters.filter(o => !(o.column === optToAdd!.column && o.type === 'contains'));
        setAppliedFilterOptions([...filters, optToAdd]);
        setSearchText('');
        filterSearch?.blur();
      }
    }
  }

  function removeFilter(optionLabel: string) {
    const optToRemove = appliedFilterOptions.find(o => o.label === optionLabel);
    if (optToRemove !== undefined) {
      setAppliedFilterOptions([...appliedFilterOptions.filter(o => o.key !== optToRemove!.key)]);
      filterSearch?.blur();
    }
  }

  function filterAllColumns() {
    const filters = appliedFilterOptions;

    const filterColumns = options.filter(o => o.type === 'contains');

    const newFilter: TableSearchOption = {
      key: `anycolumn${searchText}like`,
      column: 'anycolumn',
      value: `${searchText}|${filterColumns.map(o => o.column).join(',')}`,
      label: `Any field contains: "${searchText}"`,
      type: 'like'
    };

    const currentNonConflictingFilters = filters.filter(f => {
      return f.type != 'contains';
    });
    setAppliedFilterOptions([...currentNonConflictingFilters, newFilter]);
    setSearchText('');
  }

  return (
    <Select
      id="filterDropdown"
      showSearch
      allowClear
      mode="tags"
      placeholder="Filter results..."
      notFoundContent={options.length === 0 && searchText.length > 0 ? 'No results' : undefined}
      options={[
        ...(searchText
          ? [{ label: `Any field contains: ${searchText}`, value: 'filter-all' }]
          : []),
        ...options.slice(0, 30).map(({ key, label }, index) => ({
          label: (
            <Typography.Text style={{ maxWidth: 400 }} ellipsis>
              {label}
            </Typography.Text>
          ),
          value: key
        }))
      ]}
      onSearch={val => setSearchText(val)}
      onSelect={(o: string) => addFilter(o)}
      onClear={() => setAppliedFilterOptions([])}
      onDeselect={(o: string) => removeFilter(o)}
      value={appliedFilterOptions.map(f => {
        return f.label;
      })}
      style={{ width: '100%' }}
    />
  );
}
